import { render, staticRenderFns } from "./ModalFile.vue?vue&type=template&id=1f896406&scoped=true"
import script from "./ModalFile.vue?vue&type=script&lang=js"
export * from "./ModalFile.vue?vue&type=script&lang=js"
import style0 from "./ModalFile.vue?vue&type=style&index=0&id=1f896406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f896406",
  null
  
)

export default component.exports